import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferFragmentDoc, FastOfferFragmentDoc } from '../fragments/Offer.fragment';
import { TrailerClipsFragmentDoc } from '../../../../pages/graphql/fragments/TrailerClips.fragment';
export type GetSingleQtvSimilarTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	titleId: Types.Scalars['ID']['input'];
	language: Types.Scalars['Language']['input'];
	filters?: Types.InputMaybe<Types.TitleFilter>;
	first?: Types.Scalars['Int']['input'];
	offerFilters: Types.OfferFilter;
	sorting?: Types.InputMaybe<Types.SimilarTitlesSorting>;
	withClips?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetSingleQtvSimilarTitlesQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article'; id: string }
		| { __typename?: 'Author'; id: string }
		| { __typename?: 'Bundle'; id: string }
		| { __typename?: 'Device'; id: string }
		| { __typename?: 'Episode'; id: string }
		| { __typename?: 'GenericTitleList'; id: string }
		| { __typename?: 'Genre'; id: string }
		| { __typename?: 'HomePage'; id: string }
		| {
				__typename?: 'Movie';
				id: string;
				similarTitlesV2: {
					__typename?: 'SimilarTitlesConnection';
					edges?: Array<{
						__typename?: 'SimilarTitlesEdge';
						similarityScore?: number | null;
						node:
							| {
									__typename?: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'MovieContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										clips?: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										dailymotionClips: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										tags?: Array<{
											__typename?: 'Tag';
											technicalName: string;
											translatedName: string;
										}> | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
										genres: Array<{
											__typename?: 'Genre';
											id: string;
											translation: string;
											shortName: string;
										}>;
									};
									offers: Array<{
										__typename?: 'Offer';
										id: string;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										newElementCount?: number | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										userLocalCurrency?: string | null;
										retailPriceConverted?: string | null;
										currency?: string | null;
										lastChangeRetailPriceValue?: number | null;
										type: Types.OfferType;
										country: any;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										elementCount?: number | null;
										availableTo?: any | null;
										subtitleLanguages: Array<any>;
										videoTechnology: Array<Types.VideoTechnology>;
										audioTechnology: Array<Types.AudioTechnology>;
										audioLanguages: Array<any>;
										updatedAt?: any | null;
										mediaDealId?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											icon: string;
											iconWide: string;
											planOffers: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
												retailPriceConverted?: string | null;
												children: Array<{
													__typename?: 'PackagePlanOffer';
													title?: string | null;
													retailPrice?: string | null;
													isTrial?: boolean | null;
													durationDays?: number | null;
													retailPriceValue?: number | null;
												}>;
											}>;
										};
										plans: Array<{
											__typename?: 'PackagePlanOffer';
											title?: string | null;
											retailPrice?: string | null;
											isTrial?: boolean | null;
											durationDays?: number | null;
											retailPriceValue?: number | null;
											retailPriceConverted?: string | null;
											children: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
											}>;
										}>;
									}>;
							  }
							| {
									__typename?: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'ShowContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										clips?: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										dailymotionClips: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										tags?: Array<{
											__typename?: 'Tag';
											technicalName: string;
											translatedName: string;
										}> | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
										genres: Array<{
											__typename?: 'Genre';
											id: string;
											translation: string;
											shortName: string;
										}>;
									};
									offers: Array<{
										__typename?: 'Offer';
										id: string;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										newElementCount?: number | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										userLocalCurrency?: string | null;
										retailPriceConverted?: string | null;
										currency?: string | null;
										lastChangeRetailPriceValue?: number | null;
										type: Types.OfferType;
										country: any;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										elementCount?: number | null;
										availableTo?: any | null;
										subtitleLanguages: Array<any>;
										videoTechnology: Array<Types.VideoTechnology>;
										audioTechnology: Array<Types.AudioTechnology>;
										audioLanguages: Array<any>;
										updatedAt?: any | null;
										mediaDealId?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											icon: string;
											iconWide: string;
											planOffers: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
												retailPriceConverted?: string | null;
												children: Array<{
													__typename?: 'PackagePlanOffer';
													title?: string | null;
													retailPrice?: string | null;
													isTrial?: boolean | null;
													durationDays?: number | null;
													retailPriceValue?: number | null;
												}>;
											}>;
										};
										plans: Array<{
											__typename?: 'PackagePlanOffer';
											title?: string | null;
											retailPrice?: string | null;
											isTrial?: boolean | null;
											durationDays?: number | null;
											retailPriceValue?: number | null;
											retailPriceConverted?: string | null;
											children: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
											}>;
										}>;
									}>;
							  };
					}> | null;
				};
		  }
		| { __typename?: 'MultiStepSportEvent'; id: string }
		| { __typename?: 'Offer'; id: string }
		| { __typename?: 'OfferHistory'; id: string }
		| { __typename?: 'Package'; id: string }
		| { __typename?: 'Page'; id: string }
		| { __typename?: 'Person'; id: string }
		| { __typename?: 'ProfileV2'; id: string }
		| { __typename?: 'Season'; id: string }
		| {
				__typename?: 'Show';
				id: string;
				similarTitlesV2: {
					__typename?: 'SimilarTitlesConnection';
					edges?: Array<{
						__typename?: 'SimilarTitlesEdge';
						similarityScore?: number | null;
						node:
							| {
									__typename?: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'MovieContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										clips?: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										dailymotionClips: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										tags?: Array<{
											__typename?: 'Tag';
											technicalName: string;
											translatedName: string;
										}> | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
										genres: Array<{
											__typename?: 'Genre';
											id: string;
											translation: string;
											shortName: string;
										}>;
									};
									offers: Array<{
										__typename?: 'Offer';
										id: string;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										newElementCount?: number | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										userLocalCurrency?: string | null;
										retailPriceConverted?: string | null;
										currency?: string | null;
										lastChangeRetailPriceValue?: number | null;
										type: Types.OfferType;
										country: any;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										elementCount?: number | null;
										availableTo?: any | null;
										subtitleLanguages: Array<any>;
										videoTechnology: Array<Types.VideoTechnology>;
										audioTechnology: Array<Types.AudioTechnology>;
										audioLanguages: Array<any>;
										updatedAt?: any | null;
										mediaDealId?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											icon: string;
											iconWide: string;
											planOffers: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
												retailPriceConverted?: string | null;
												children: Array<{
													__typename?: 'PackagePlanOffer';
													title?: string | null;
													retailPrice?: string | null;
													isTrial?: boolean | null;
													durationDays?: number | null;
													retailPriceValue?: number | null;
												}>;
											}>;
										};
										plans: Array<{
											__typename?: 'PackagePlanOffer';
											title?: string | null;
											retailPrice?: string | null;
											isTrial?: boolean | null;
											durationDays?: number | null;
											retailPriceValue?: number | null;
											retailPriceConverted?: string | null;
											children: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
											}>;
										}>;
									}>;
							  }
							| {
									__typename?: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'ShowContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										clips?: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										dailymotionClips: Array<{
											__typename?: 'Clip';
											sourceUrl: string;
											externalId: string;
											provider: Types.ClipProvider;
											name: string;
											sources: {
												__typename?: 'Sources';
												dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
											};
										}>;
										tags?: Array<{
											__typename?: 'Tag';
											technicalName: string;
											translatedName: string;
										}> | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
										genres: Array<{
											__typename?: 'Genre';
											id: string;
											translation: string;
											shortName: string;
										}>;
									};
									offers: Array<{
										__typename?: 'Offer';
										id: string;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										newElementCount?: number | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										userLocalCurrency?: string | null;
										retailPriceConverted?: string | null;
										currency?: string | null;
										lastChangeRetailPriceValue?: number | null;
										type: Types.OfferType;
										country: any;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										elementCount?: number | null;
										availableTo?: any | null;
										subtitleLanguages: Array<any>;
										videoTechnology: Array<Types.VideoTechnology>;
										audioTechnology: Array<Types.AudioTechnology>;
										audioLanguages: Array<any>;
										updatedAt?: any | null;
										mediaDealId?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											icon: string;
											iconWide: string;
											planOffers: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
												retailPriceConverted?: string | null;
												children: Array<{
													__typename?: 'PackagePlanOffer';
													title?: string | null;
													retailPrice?: string | null;
													isTrial?: boolean | null;
													durationDays?: number | null;
													retailPriceValue?: number | null;
												}>;
											}>;
										};
										plans: Array<{
											__typename?: 'PackagePlanOffer';
											title?: string | null;
											retailPrice?: string | null;
											isTrial?: boolean | null;
											durationDays?: number | null;
											retailPriceValue?: number | null;
											retailPriceConverted?: string | null;
											children: Array<{
												__typename?: 'PackagePlanOffer';
												title?: string | null;
												retailPrice?: string | null;
												isTrial?: boolean | null;
												durationDays?: number | null;
												retailPriceValue?: number | null;
											}>;
										}>;
									}>;
							  };
					}> | null;
				};
		  }
		| { __typename?: 'SingleStepSportEvent'; id: string }
		| { __typename?: 'SportCompetitionV2'; id: string }
		| { __typename?: 'SportCompetitorV2'; id: string }
		| { __typename?: 'SportMatch'; id: string }
		| { __typename?: 'Url'; id: string }
		| { __typename?: 'UserProviderSubscription'; id: string }
		| null;
};

export type SingleQtvSimilarTitle_Movie_Fragment = {
	__typename?: 'Movie';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	content: {
		__typename?: 'MovieContent';
		title: string;
		posterUrl?: string | null;
		fullPath: string;
		tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
		backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
		scoring: {
			__typename?: 'Scoring';
			imdbVotes?: number | null;
			imdbScore?: number | null;
			tomatoMeter?: number | null;
			certifiedFresh?: boolean | null;
			jwRating?: number | null;
		};
		interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
		genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
	};
};

export type SingleQtvSimilarTitle_Show_Fragment = {
	__typename?: 'Show';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	content: {
		__typename?: 'ShowContent';
		title: string;
		posterUrl?: string | null;
		fullPath: string;
		tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
		backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
		scoring: {
			__typename?: 'Scoring';
			imdbVotes?: number | null;
			imdbScore?: number | null;
			tomatoMeter?: number | null;
			certifiedFresh?: boolean | null;
			jwRating?: number | null;
		};
		interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
		genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
	};
};

export type SingleQtvSimilarTitleFragment = SingleQtvSimilarTitle_Movie_Fragment | SingleQtvSimilarTitle_Show_Fragment;

export const SingleQtvSimilarTitleFragmentDoc = gql`
	fragment SingleQtvSimilarTitle on MovieOrShow {
		id
		objectId
		objectType
		content(country: $country, language: $language) {
			title
			posterUrl
			fullPath
			backdrops {
				backdropUrl
			}
			scoring {
				imdbVotes
				imdbScore
				tomatoMeter
				certifiedFresh
				jwRating
			}
			interactions {
				votesNumber
			}
			genres {
				id
				translation(language: $language)
				shortName
			}
		}
		... on Movie {
			content(country: $country, language: $language) {
				tags {
					technicalName
					translatedName
				}
			}
		}
		... on Show {
			content(country: $country, language: $language) {
				tags {
					technicalName
					translatedName
				}
			}
		}
	}
`;
export const GetSingleQtvSimilarTitlesDocument = gql`
	query GetSingleQtvSimilarTitles(
		$country: Country!
		$titleId: ID!
		$language: Language!
		$filters: TitleFilter
		$first: Int! = 1
		$offerFilters: OfferFilter!
		$sorting: SimilarTitlesSorting
		$withClips: Boolean = false
	) {
		node(id: $titleId) {
			id
			... on MovieOrShow {
				similarTitlesV2(country: $country, filter: $filters, first: $first, sorting: $sorting) {
					edges {
						node {
							...SingleQtvSimilarTitle
							offers(country: $country, platform: WEB, filter: $offerFilters) {
								...TitleOffer
							}
							... on Movie {
								content(country: $country, language: $language) {
									clips(country: $country, language: "en", first: 4) @include(if: $withClips) {
										...TrailerClips
									}
									dailymotionClips: clips(
										providers: [DAILYMOTION]
										country: $country
										language: "en"
										first: 4
									) @include(if: $withClips) {
										...TrailerClips
									}
								}
							}
							... on Show {
								content(country: $country, language: $language) {
									clips(country: $country, language: "en", first: 4) @include(if: $withClips) {
										...TrailerClips
									}
									dailymotionClips: clips(
										providers: [DAILYMOTION]
										country: $country
										language: "en"
										first: 4
									) @include(if: $withClips) {
										...TrailerClips
									}
								}
							}
						}
						similarityScore
					}
				}
			}
		}
	}
	${SingleQtvSimilarTitleFragmentDoc}
	${TitleOfferFragmentDoc}
	${TrailerClipsFragmentDoc}
`;
